import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Navigation } from '@ampdx/component-library/dist/components/'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../shared/utils/common-utils'
import { reactToCwp } from '../../../common/react-utils'
import { cacheGet, refreshDataVersion } from '@ampdx/component-library/src/utils'

const NavigationMicrosite = props => {
  const { menuName, layout, textClass } = props.content
  const [windowWidth, setWindowWidth] = useState(0)
  const [mainMenu, setMainMenu] = useState({})

  const env = getCWPEnvironmentForURL(window.location.href)
  useEffect(() => {
    const navEvent = new Event('NavLoaded')
    dispatchEvent(navEvent)
    const handleWindowSizeChange = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleWindowSizeChange)
    setWindowWidth(window.innerWidth)
    async function fetchCacheVersion() {
      if (window.innerWidth >= 1025) {
        await refreshDataVersion(
          `${APIENDPOINT(env).base}halapi/resourcebundles/ampmicrosites.cacheversion`
        )
      }
    }
    fetchCacheVersion()

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  useEffect(() => {
    async function fetchMenu() {
      const micrositeMenuUrl = `${APIENDPOINT(env).menuBaseWithParams}${menuName}`
      const mainMenu = await cacheGet(windowWidth >= 1025 ? micrositeMenuUrl : '')
      setMainMenu(mainMenu)
    }
    fetchMenu()
  }, [windowWidth])

  const { status: menuStatus, error: menuError } = mainMenu || {}
  switch (menuStatus) {
    case 'idle': {
      return <div />
    }
    case 'error': {
      return <div>{menuError}</div>
    }
    case 'fetching': {
      return <div className='loading' />
    }
    case 'fetched': {
      return (
        <Navigation
          mainMenu={mainMenu}
          layoutClass={layout}
          textSizeClass={textClass}
          styles={{
            navBackgroundColor: '#F5F5F5',
            linkTextColor: '#046cb8',
            linkTextColorHover: '#00284a',
            navTabHoverBorderBottom: 'rgba(0, 40, 75, 0.5)',
            navTabHoverBackgroundColor: '#F5F5F5',
            navTabSelectedBorderBottom: '#00284a',
          }}
        />
      )
    }
  }
}

NavigationMicrosite.propTypes = {
  content: PropTypes.shape({
    menuName: PropTypes.string.isRequired,
    layout: PropTypes.string,
    textClass: PropTypes.string,
  }).isRequired,
}

export default reactToCwp(NavigationMicrosite)
